import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { Radii, Spacing } from '~/types/ThemeTypes'

const { shared } = themeColorSectionKeys

const tagStyleParts = ['container', 'label', 'closeButton'] as const

const helpers = createMultiStyleConfigHelpers(tagStyleParts)
export enum TagVariant {
  TagInput = 'tagInput',
  Subtle = 'subtle',
  Solid = 'solid',
  Outline = 'outline',
}
export const TagStyle = helpers.defineMultiStyleConfig({
  variants: {
    [TagVariant.TagInput]: {
      container: {
        height: Spacing._6,
        padding: Spacing._2,
        borderRadius: Radii._3xl,
        bg: shared.TagInput.Background,
        color: shared.TagInput.FontColor,
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  },
})
